// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__19HYZ","footer":"ModalInfo_footer__3jS3R"};